import { render, staticRenderFns } from "./DesignTableHeader.vue?vue&type=template&id=6906bb36&scoped=true&"
import script from "./DesignTableHeader.vue?vue&type=script&lang=js&"
export * from "./DesignTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesignTableHeader.vue?vue&type=style&index=0&id=6906bb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6906bb36",
  null
  
)

export default component.exports